import type { RefObject } from 'react';
import { createContext } from 'react';

type SidePanelToggleContextValue = {
  isOpen: boolean;
  openPanel: () => void;
  closePanel: () => void;
};

export const SidePanelToggleContext = createContext<SidePanelToggleContextValue>({
  isOpen: false,
  openPanel: () => undefined,
  closePanel: () => undefined,
});

export const SidePanelHeightAnchorRefContext = createContext<RefObject<HTMLElement> | undefined>(undefined);
